
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.26 20c-4.687 0-9.37 1.834-12.927 5.456-7.116 7.246-7.105 18.953 0 26.203L49.53 79.394a2.585 2.585 0 001.841.773c.695 0 1.357-.279 1.84-.773 9.078-9.241 18.149-18.467 27.225-27.708 7.115-7.246 7.115-18.957 0-26.203-7.115-7.247-18.765-7.247-25.88 0l-3.172 3.224-3.198-3.251C44.628 21.834 39.946 20 35.259 20zm0 5.106c3.332 0 6.657 1.317 9.244 3.951l5.053 5.133a2.585 2.585 0 001.84.773c.696 0 1.358-.279 1.842-.773l4.998-5.106c5.177-5.27 13.34-5.27 18.517 0s5.177 13.703 0 18.973c-8.459 8.614-16.911 17.24-25.37 25.854L26.014 48.03c-5.173-5.278-5.177-13.703 0-18.974 2.587-2.633 5.913-3.95 9.245-3.95z"}})])
          )
        }
      }
    